import {
    LOGIN,
    VALIDATE_EMAIL,
} from "redux/reducers/core/authentication/actionNames"

const mapper = {
    [LOGIN](_, result, originalPayload) {
        if (!result) return result

        return {
            result: {
                ...result,
                companies: result?.companies?.map(company => ({
                    ...company,
                    roles: company?.userRoles || company?.roles,
                })),
            },
            originalPayload,
        }
    },

    [VALIDATE_EMAIL](_, result, originalPayload) {
        if (!result) return result

        return {
            result: {
                ...result,
                companies: result?.companies?.map(company => ({
                    ...company,
                    roles: company?.userRoles || company?.roles,
                })),
            },
            originalPayload,
        }
    },
}

export default mapper
